import * as React from "react";
import NewsCard from "./molecules/NewsCard";
import Pagination from "./molecules/Pagination";
const MyFav = ({ pageNumber, setPageNumber }) => {
  const [storedHackerNewsLiked, setStoredHackerNewsLiked] = React.useState(
    JSON.parse(localStorage.getItem("hackerNewsLiked")) || []
  );

  const fetchLocalStorageData = () => {
    setStoredHackerNewsLiked(
      JSON.parse(localStorage.getItem("hackerNewsLiked"))
    );
  };

  if (!storedHackerNewsLiked || !storedHackerNewsLiked.length)
    return (
      <div>
        <br /> No Liked News yet
      </div>
    );

  return (
    <>
      <div className="news_body">
        {storedHackerNewsLiked.map((d, i) => (
          <NewsCard data={d} key={i} onClickLike={fetchLocalStorageData} />
        ))}
      </div>
      <br />
      <Pagination
        className="pagination-bar"
        currentPage={pageNumber}
        totalCount={storedHackerNewsLiked.length}
        pageSize={20}
        onPageChange={(pageNumber) => setPageNumber(pageNumber)}
      />
    </>
  );
};
export default MyFav;
